import { ResourceType } from './Resource';
import { ActionType } from '@/components/permissions/Action.tsx';

export interface Permission {
  description: string;
  action: ActionType;
  resource: ResourceType;
  isBasic?: boolean;
  isRoot?: boolean;
  name: string;
}

export function createPermission(
  description: string,
  action: ActionType,
  resource: ResourceType,
  isBasic = false,
  isRoot = false
): Permission {
  return {
    description,
    action,
    resource,
    isBasic,
    isRoot,
    name: PermissionNameFor(action, resource)
  };
}

export function PermissionNameFor(resource: string, action: string): string {
  return `Permissions.${resource}.${action}`;
}
